import React, { PropsWithChildren } from "react";
import SlickSlider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const sliderSettings = {
  arrows: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  vertical: false,
  dots: true,
};

const styles = `
.dots {
  display: flex !important;
  justify-content: center;
  margin-top: 18px;
  width: 100%;
  justify-content: center;
  
}

.dots>li {
  flex: 1 1 0px;
  margin: 0 10px;
  max-width: 50px;
}

.dots>li>button {
  margin: 0 12px;
  height: 4px;
  background: #E5E7EB;
  color: transparent;
  width: 100%;
}

.dots>li.slick-active>button {
  background: #afafaf;
}
`;

export const Slider: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <div>
      <SlickSlider {...sliderSettings} className="w-full" dotsClass="dots">
        {children}
      </SlickSlider>
      <style>{styles}</style>
    </div>
  );
};
